export var ASSESSMENT_BLOCK_TYPES = Object.freeze({
  SELF_ASSESSMENT_BLOCK: "Haldor.Blocks.AssessmentBlock.Self",
  PEER_REVIEW_BLOCK: "Haldor.Blocks.AssessmentBlock.Peer",
  TEACHER_ASSESSMENT_BLOCK: "Haldor.Blocks.AssessmentBlock"
});